"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoutFirebaseStartAction = exports.loginFirebaseErrorAction = exports.loginFirebaseSuccessAction = exports.refreshFirebaseAuth = exports.loginFirebaseStartAction = exports.REFRESH_FIREBASE_AUTH = exports.LOGOUT_FIREBASE_START = exports.LOGIN_FIREBASE_ERROR = exports.LOGIN_FIREBASE_SUCCESS = exports.LOGIN_FIREBASE_START = void 0;
const actionMaker_1 = __importDefault(require("../actionMaker"));
exports.LOGIN_FIREBASE_START = 'LOGIN_FIREBASE_START';
exports.LOGIN_FIREBASE_SUCCESS = 'LOGIN_FIREBASE_SUCCESS';
exports.LOGIN_FIREBASE_ERROR = 'LOGIN_FIREBASE_ERROR';
exports.LOGOUT_FIREBASE_START = 'logout_FIREBASE_START';
exports.REFRESH_FIREBASE_AUTH = 'REFRESH_FIREBASE_AUTH';
exports.loginFirebaseStartAction = (0, actionMaker_1.default)(exports.LOGIN_FIREBASE_START);
exports.refreshFirebaseAuth = (0, actionMaker_1.default)(exports.REFRESH_FIREBASE_AUTH);
exports.loginFirebaseSuccessAction = (0, actionMaker_1.default)(exports.LOGIN_FIREBASE_SUCCESS, 'data');
exports.loginFirebaseErrorAction = (0, actionMaker_1.default)(exports.LOGIN_FIREBASE_ERROR, 'data');
exports.logoutFirebaseStartAction = (0, actionMaker_1.default)(exports.LOGOUT_FIREBASE_START);
const LoginFirebaseActions = {
    loginFirebaseStartAction: exports.loginFirebaseStartAction,
    loginFirebaseSuccessAction: exports.loginFirebaseSuccessAction,
    loginFirebaseErrorAction: exports.loginFirebaseErrorAction,
    logoutFirebaseStartAction: exports.logoutFirebaseStartAction,
};
exports.default = LoginFirebaseActions;
